export const VAR_LIST = 'VarList';
export const INT_LIST = 'IntList';
export const PICKLIST = 'Picklist';
